module.exports = __webpack_public_path__ + "static/media/search.f18c2e2c.svg";